export type DiscoverySource =
  | 'google_search'
  | 'social_media'
  | 'instagram_message'
  | 'friend_colleague'
  | 'event_conference'
  | 'article_newsletter'
  | 'other';

export const SCREEN_3_OPTIONS: { value: DiscoverySource; label: string }[] = [
  { value: 'google_search', label: 'Google or another search engine' },
  { value: 'social_media', label: 'Social media' },
  { value: 'instagram_message', label: 'An Instagram message or story' },
  { value: 'friend_colleague', label: 'A friend or colleague' },
  { value: 'event_conference', label: 'An event or conference' },
  { value: 'article_newsletter', label: 'An article, blog, or newsletter' },
  { value: 'other', label: 'Other' }
];

const DISCOVERY_SOURCE_VALUES: string[] = SCREEN_3_OPTIONS.map((o) => o.value);

/**
 * The persisted discovery_source column holds raw user text for "Other", so any
 * value off this list must collapse to the category before reaching analytics.
 */
export function toCanonicalDiscoverySource(
  value: string | null | undefined
): DiscoverySource | null {
  if (value == null || value.trim() === '') return null;
  return DISCOVERY_SOURCE_VALUES.includes(value) ? (value as DiscoverySource) : 'other';
}
